const getEditorStyle = (lang) => ({
    minHeight: "200px",
    direction: lang === "sa" ? "rtl" : "ltr",
    textAlign: lang === "sa" ? "right" : "left",
  });
  
  const wrapperStyle = {
    borderRadius: "12px",
    border: "1px solid #dee2e6", // optional, for consistent border
  };
  
  const toolbarOptions = {
    options: ["inline", "list", "textAlign", "remove"],
    inline: { options: ["bold", "italic", "underline"] },
    list: { options: ["unordered", "ordered"] },
    textAlign: { options: ["left", "center", "right"] },
  };
  
  export {getEditorStyle, wrapperStyle, toolbarOptions}